import { getFontFamily } from 'src/app/project/modules/white-label/white-label-utils/get-font-family';
import { TDashletGraphOptions } from '../../dashlet-graph.model';
import { createBarGraphTooltipLabel } from './create-bar-graph-tooltip-label';

const fontColor = '#586378';

export function generateStackedBarGraphOptions(isExport: boolean): TDashletGraphOptions {
  const fontSize = isExport ? 42 : 12;
  const fontFamily = getFontFamily();

  return {
    devicePixelRatio: window.devicePixelRatio,
    scales: {
      x: {
        stacked: true,
        ticks: {
          font: {
            size: fontSize,
            color: fontColor,
            family: fontFamily,
          },
        },
      },
      y: {
        stacked: true,
        ticks: {
          min: 0,
          font: {
            size: fontSize,
            color: fontColor,
            family: fontFamily,
          },
          maxTicksLimit: 7,
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        onClick: null,
        position: 'top',
        labels: {
          pointStyle: 'circle',
          boxWidth: 10,
          boxHeight: 10,
          font: {
            size: fontSize,
            color: fontColor,
            family: fontFamily,
          },
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            return createBarGraphTooltipLabel(tooltipItem);
          },
        },
      },

      datalabels: {
        display: (value) => false,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    cutout: 55,
  };
}
